type RestoreCategorySearchScrollPositionOptions = {
    scrollY: number | null;
    onFinish: () => void;
};

const getDocumentMaxScroll = (): number => Math.max(0, document.documentElement.scrollHeight - window.innerHeight);

export const restoreCategorySearchScrollPosition = ({ scrollY, onFinish }: RestoreCategorySearchScrollPositionOptions): void => {
    if (typeof window === 'undefined' || scrollY === null) {
        return;
    }

    const maxAttempts = 60;
    const threshold = 2;
    let attempts = 0;

    const restore = (): void => {
        attempts += 1;

        if (getDocumentMaxScroll() < scrollY) {
            if (attempts >= maxAttempts) {
                onFinish();
                return;
            }

            window.requestAnimationFrame(restore);
            return;
        }

        window.scrollTo({ top: scrollY, behavior: 'auto' });

        if (Math.abs(window.scrollY - scrollY) <= threshold || attempts >= maxAttempts) {
            onFinish();
            return;
        }

        window.requestAnimationFrame(restore);
    };

    window.requestAnimationFrame(restore);
};
